import {LIVE_DOMAIN, REACT_APP_ENV, TICK_DOMAIN} from '../config/config';

export default function getEventUrl (eventDomain, pageUrl, eventType, currentDomain){
    if(REACT_APP_ENV === 'production' && eventDomain)
        return `https://${eventDomain}/${pageUrl}`;
    currentDomain = currentDomain || (['hub','subscription'].includes(eventType) ? LIVE_DOMAIN : TICK_DOMAIN);
    return `${currentDomain}/${pageUrl}`;
}